import {
  EpidemiologyDataOptions,
  EpidemiologyDataResponse,
  PrevProjDataOptions,
  PrevProjDataResponse,
} from "@/dashboard-api-types/api/epidemiologyData.types";
import { post } from "../../httpClients/clients/http.client";

const BASE_PATH = "/epidemiology";

export const EpidemiologyApi = {
  postByLocCodeAndOptions: (locCode: number, body: EpidemiologyDataOptions, signal?: AbortSignal) =>
    post<EpidemiologyDataResponse>(`${BASE_PATH}/${locCode}`, body, { signal }),
};

export const EpidemiologyPrevProjApi = {
  postByLocCodeAndOptions: (locCode: number, body: PrevProjDataOptions, signal?: AbortSignal) =>
    post<PrevProjDataResponse>(`${BASE_PATH}/prevProj/${locCode}`, body, { signal }),
};
